import { store } from '../store';
import { api, apiMain } from './config/axios';

const getAppId = () => {
  const activeApp = localStorage.getItem('activeApp');
  if (activeApp) {
    const app = JSON.parse(activeApp);
    return app._id;
  }
  const bootstrappedApp = sessionStorage.getItem('bootstrappedApp');
  if (bootstrappedApp) {
    const app = JSON.parse(bootstrappedApp);
    return app._id;
  }
  return null;
};

const getConfig = () => {
  const { token } = store.getState().auth;
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

export const getStaffMembers = () => {
  const { token } = store.getState().auth;
  const appId = getAppId();

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return apiMain.get(`/api/v1/user/apps/${appId}/staff`, {}, config);
};

export const createStaffMember = (data) => {
  const appId = getAppId();
  const endpoint = data.password
    ? `/api/v1/user/apps/${appId}/staff/direct`
    : `/api/v1/user/apps/${appId}/staff/invite`;

  return apiMain.post(endpoint, data, getConfig());
};

export const updateStaffMember = (userId, data) => {
  const appId = getAppId();
  return apiMain.put(`/api/v1/user/apps/${appId}/staff/${userId}`, data, getConfig());
};

export const removeStaffMember = (userId) => {
  const appId = getAppId();
  return apiMain.delete(`/api/v1/user/apps/${appId}/staff/${userId}`, {}, getConfig());
};

export const getUsers = (query) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.get('/api/v1/admin/agents', query, config);
};

export const getDashboardOverview = () => {
  const { token } = store.getState().auth;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.get('/api/v1/admin/dashboard/overview', {}, config);
};

export const queryUserData = (payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.post('/api/v1/admin/agents/query', payload, config);
};

export const getUserById = (id) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.get(`/api/v1/admin/agents/details/${id}`, {}, config);
};

export const createUser = (data) => api.post('/api/v1/auth/admin/users/', data);
export const getUser = (userId) => api.get(`/api/v1/auth/admin/users/${userId}/`);
export const updateUser = (userId, data) => api.get(`/api/v1/auth/admin/users/${userId}/`, data);
export const removeUser = (userId) => api.delete(`/api/v1/auth/admin/users/${userId}/`);

export const getUsersWallet = (query) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.get('/api/v1/admin/agents/wallet', query, config);
};

export const fundUsersWallet = (userId, payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.post(`/api/v1/admin/agents/wallet/${userId}`, payload, config);
};

export const changeUserPassword = (payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.post(`/api/v1/admin/agents/change-password`, payload, config);
};

export const changeAgentStatus = (payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.post(`/api/v1/admin/agents/change-agent-status`, payload, config);
};

export const sendAgentMessage = (payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.post(`/api/v1/admin/agents/message`, payload, config);
};

export const getNotification = () => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.get('/api/v1/admin/notify', {}, config);
};

export const createNotification = (payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.post(`/api/v1/admin/notify`, payload, config);
};

export const updateNotification = (userId, payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.post(`/api/v1/admin/agents/wallet/${userId}`, payload, config);
};

export const deleteNotification = (notifyId) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.delete(`/api/v1/admin/notify/${notifyId}`, {}, config);
};

export const getReferelInfo = () => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.get('/api/v1/admin/referel', {}, config);
};

export const updateReferelnfo = (payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.post('/api/v1/admin/referel', payload, config);
};

export const agentDeductUser = async () => {};
export const checkDeductionDetail = async () => {};

export const agentFundUserWallet = async () => {};

export const sendUserEmail = (payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.post('/api/v1/admin/agents/message', payload, config);
};

export const updateUserInfo = (payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.post('/api/v1/admin/agents/change-password', payload, config);
};

export const updateUserPassword = (payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.post('/api/v1/admin/referel', payload, config);
};

export const sendUserMessage = (payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.post('/api/v1/admin/referel', payload, config);
};

export const sendPushNotification = (payload) => {
  const { token } = store.getState().auth;

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return api.post('/api/v1/admin/notifications', payload, config);
};

export const getMyPendingInvitations = () => {
  const { token } = store.getState().auth;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return apiMain.get(`/api/v1/user/staff/invitations`, {}, config);
};

export const acceptStaffInvitation = (staffId) => {
  const { token } = store.getState().auth;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return apiMain.post(`/api/v1/user/staff/invitations/${staffId}/accept`, {}, config);
};

export const getUserApps = (params) => {
  const { token } = store.getState().auth;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params,
  };
  return apiMain.get(`/api/v1/user/apps`, params, config);
};

export const getUserApp = (appId) => {
  const { token } = store.getState().auth;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return apiMain.get(`/api/v1/user/apps/${appId}`, {}, config);
};

export const getPermissionsCatalog = () => {
  const { token } = store.getState().auth;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return apiMain.get(`/api/v1/user/permissions`, {}, config);
};
